import React from "react"
import Layout from "../../components/Layout"
import SEO from "../../components/Seo"
import Banner from "../../components/IELTS_Academic/Banner"
import Menu from "../../components/IELTS_Academic/Menu"
import ListeningModule from "../../components/IELTS_Academic/ListeningModule"
import RecomendedCourses from "../../components/IELTS_Academic/RecomendedCourses"

const Listening = () => (
  <Layout>
    <SEO title="IELTS Academic - Listening" />
    <main>
        <Banner />
        <Menu />
        <ListeningModule />
        <RecomendedCourses />
    </main>
  </Layout>
)

export default Listening
